module.exports = __webpack_public_path__ + "static/media/Gabite_gaussian2.b2445856.png";